<template>
  <div :id="'school-' + school.school_id" class="schoolview">
    <div class="schoolInfo">
      <h2> {{ school.abbreviated_name }} </h2>
      <dl>
        <dt v-if="school.school_level" >School Level</dt>
        <dd v-if="school.school_level">{{ school.school_level }}</dd>
        <dt v-if="school.admission_type">Admission Type</dt>
        <dd v-if="school.admission_type">{{ school.admission_type }}</dd>
        <dt v-if="school.year_opened">Year Opened</dt>
        <dd v-if="school.year_opened">{{ school.year_opened }}</dd>
        <dt v-if="school.age">Age (in years)</dt>
        <dd v-if="school.age">{{ school.age }}</dd>
        <dt v-if="school.website">Website</dt>
        <dd v-if="school.website"><a :href="school.website" target="_blank">{{ school.website }}</a></dd>
        <dt v-if="school.school_leader_name">Principal</dt>
        <dd v-if="school.school_leader_name">{{ school.school_leader_name }}</dd>
        <dt v-if="school.zip_code">Zip Code</dt>
        <dd v-if="school.zip_code">{{ school.zip_code }}</dd>
      </dl>
      <div class="problemTypes">
        <h4>Problems</h4>
        <button :class="'prob-tag prob-bg-' + type.id" v-for="type in schoolProblems" v-bind:key="type['.id']">{{ type.name }}</button>
      </div>
    </div>
    <div class="problems"><div class="inner">
      <problem-view v-for="problem in school.problems" canedit v-bind:key="problem['.id']" :problem="problem" @imagePicked="selectImage" @editProblem="editProblem" />
    </div></div>
    <div v-if="selectedImage" class="modal" @click="selectedImage = null">
      <div class="inner">
        <span class="close" @click="selectedImage = null">close</span>
        <img :src="selectedImage.downloadUrl" />
      </div>
    </div>
  </div>
</template>

<script>
  import ProblemView from '@/components/NewProblemView.vue'
  import { groupBy } from '@/utils'
  export default {
    name: 'SchoolView',
    components: {
      ProblemView
    },
    props: {
      school: Object
    },
    data() {
      return {
        selectedImage: null
      }
    },
    computed: {
      schoolProblems () {
        if (this.school.problems) {
          const groupedProblems = groupBy(this.school.problems, 'problemVal')
          return Object.keys(groupedProblems).map((key, index) => {
            return {
              'name': groupedProblems[key][0].problemType.shortLabel,
              'id': key
            }
          })
        }
        return []
      }
    },
    methods: {
      selectImage (image) {
        this.selectedImage = image
      },
      editProblem (problem) {
        this.$emit('editProblem', problem)
      }
    },
  }
</script>

<style scoped>
.schoolview {
  background: white;
  margin: 15px;
  border-bottom: 1px solid #b6afaf;
  padding: 15px 0 30px;
  display: grid;
  grid-template-columns: 14% 84%;
  grid-template-rows: auto;
  grid-column-gap: 2%;
}
.schoolInfo {
  padding: 0 15px;
}
.schoolInfo h2 {
  margin: 0%;
}
.schoolInfo dt {
  font-weight:bold;
}
.schoolInfo dd {
  margin: 0 0 10px 0%;
}
.problemTypes h4 {
  font-size: 0.9rem;
  margin: 0 0 2px;
}
.problemTypes button {
  width: max-content;
  margin-bottom: 5px;
}
.problems .inner {
  display: grid;
  grid-template-columns: 24% 24% 23% 23%;
  grid-template-rows: auto;
  grid-row-gap: 20px;
  grid-column-gap: 2%;
}
.problems .problem >>> .school {
  display: none;
}
.problems .problem >>> .location-detail {
  font-weight: 500;
  color: #242424;
  font-size: 1rem;
}
.dot {
  height: 25px;
  width: 25px;
  background-color:#fff;
  border-radius: 50%;
  display: inline-block;
  border: 1px solid purple;
}
span.dot {
  text-align: center;
  vertical-align: middle;
}

hr {
height: 1px;
border: 0;
color: #333;
background-color: #333;
width: 100%;
} 
</style>